import { CommonsConfigTypes } from "./types/commons-config-types";

export const CommonsConfig: CommonsConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
